import { render, staticRenderFns } from "./cardiovascular.vue?vue&type=template&id=6654a848&scoped=true&"
import script from "./cardiovascular.vue?vue&type=script&lang=js&"
export * from "./cardiovascular.vue?vue&type=script&lang=js&"
import style0 from "./cardiovascular.vue?vue&type=style&index=0&id=6654a848&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654a848",
  null
  
)

export default component.exports